import { useEffect, useMemo, useState } from "react";
import { ContenidoPeriodo, PeriodosAdapter } from "../../../../../../../infraestructure/persistence/rest/PeriodosAdapter"
import { useNotifications } from "../../../../../../../shared/hooks/Notifications";
import { ServerErrorMessage } from "../../../../../../../shared/utils/error";
import { ContenidoVersion } from "./contenidoVersion"


export const TiposContenido = (props:any) =>{

    const {contenidos, periodo, ejercicio, onChange}=props;

    const api = new PeriodosAdapter();
	const { exceptionError, resultError } = useNotifications();
	const [data, setData] = useState<any>([])
	let result: any;
  
    useEffect(()=>{
        periodo && getContenidosPeriodo(periodo, ejercicio);
    },[periodo, ejercicio])

	const getContenidosPeriodo = async (periodo: number, año: number) => {
		try {
			result = await api.ListarContenidosPeriodo(periodo, año);
			if(result.data && result.data!=="")
			{
				setData([ ...result.data ] || []);
			}else{resultError()}
		} catch (error) {
			let exception = ServerErrorMessage(error);
			exceptionError(exception)
		}
    };

    const getContenidos = useMemo(() =>{
        return data.map((c:ContenidoPeriodo)=>{
            const contenido = contenidos && contenidos.find((f:ContenidoPeriodo) => f.idTipoContenido === c.idTipoContenido);
            const newContenido = {...c,...contenido}
            return (
                <ContenidoVersion key={c.idTipoContenido} data={newContenido} periodo={periodo} ejercicio={ejercicio} onChange={onChange}/>
            )
        })
    },[data, contenidos, periodo])
  
    return (
            data.length > 0 ? <>{getContenidos}</> : null
    )
}